// @ actions
const signaturePatternActions = require('actions/signaturePattern');
// @ constants
const actionTypes = require('constants/actionTypes');
const { CARD_TRANSFER_COMMISSION_PERCENT } = require('constants/index');

// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder.js');

const setAmount = (amount) => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_SET_AMOUNT,
        payload: {
            amount,
            commission: amount * CARD_TRANSFER_COMMISSION_PERCENT / 100
        }
    };
}

const setVisibleStep = (step) => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

const validateStep = (step) => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_VALIDATE_STEP,
        payload: {
            step
        }
    }
}

const setWillCancel = (willCancel) => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

const clearRequest = () => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_CLEAR
    };
}

const successTransfer = () => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_SUCCESS
    };
}

const requestTransfer = () => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_REQUEST
    };
}

const failureTransfer = (error) => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_FAILURE,
        error
    };
}

const requestTransferMoneyFromCCToAccountDetailsSuccess = (cardDetails) =>{
    return {
        type: actionTypes.CARD_TRANSFER_DETAILS_SUCCESS,
        payload: {cardDetails}
    };
}

const requestTransferMoneyFromCCToAccountDetailsFailure = (error) => {
    return {
        type: actionTypes.CARD_TRANSFER_DETAILS_ERROR,
        payload: {error}
    };
}

const setTotalAvailableBalance = (totalAvailableBalance) => {
    return {
        type: actionTypes.CARD_TRANSFER_MONEY_AVAILABLE_BALANCE,
        payload: {
            totalAvailableBalance
        }
    };
}

function requestTransferMoneyFromCCToAccountDetails(){
    return {
        type: actionTypes.CARD_TRANSFER_DETAILS_REQUEST
    };
}

const getTransferMoneyFromCCToAccountDetails = (immCard, titularPan) => (dispatch) => {
    const requestData = {
        query:  {
            numeroTarjetaPin: titularPan,
            producto: immCard.getIn(['contract', 'product']),
            numeroContrato: immCard.getIn(['contract', 'number'])
        }
    };
    dispatch(requestTransferMoneyFromCCToAccountDetails())

    return APIPost({
        dispatch,
        endpoint: 'cardDirectMoneyDetails',
        params: requestData
    })
    .then(responseSuccess => dispatch(requestTransferMoneyFromCCToAccountDetailsSuccess(responseSuccess.response)))
    .catch(error => dispatch(requestTransferMoneyFromCCToAccountDetailsFailure(error)))
}

const postTransfer = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCardTransferMoneyCardDetails = getState().cardTransferMoney.get('cardDetails');
        const immCardTransferMoney = getState().cardTransferMoney;
        let requestData;

        if(immCardTransferMoneyCardDetails.isEmpty()){
            requestData = {
                query: {dataToken}
            }
        } else {
             requestData = {
                query:  {
                    coestrefcodigoEstadoReferencia: immCardTransferMoneyCardDetails.get('coestrefcodigoEstadoReferencia'),
                    contratoTarjeta: {
                      numerodecontrato: immCardTransferMoneyCardDetails.getIn(['contratoTarjeta', 'numerodecontrato']),
                      producto:  immCardTransferMoneyCardDetails.getIn(['contratoTarjeta', 'producto'])
                    },
                    cuentaIngresoAsoContrato: {
                      codbban: immCardTransferMoneyCardDetails.getIn(['cuentaIngresoAsoContrato', 'codbban']),
                      digitodecontrol: immCardTransferMoneyCardDetails.getIn(['cuentaIngresoAsoContrato', 'digitodecontrol']),
                      pais: immCardTransferMoneyCardDetails.getIn(['cuentaIngresoAsoContrato','pais'])
                    },
                    dataToken,
                    idsubtipcodSudtipoProductoContrato: immCardTransferMoneyCardDetails.get('idsubtipcodSudtipoProductoContrato'),
                    jimppdtesaldoDipantesyDespTrasp: {
                      divisa: immCardTransferMoneyCardDetails.getIn(['jimppdtesaldoDipantesyDespTrasp', 'divisa']),
                      importe: immCardTransferMoneyCardDetails.getIn(['jimppdtesaldoDipantesyDespTrasp', 'importe'])
                    },
                    jmodalidmodalidadFormaPago: immCardTransferMoneyCardDetails.get('jmodalidmodalidadFormaPago'),
                    jreclpagimporteTraspaso: {
                      divisa: immCardTransferMoney.getIn(['steps','0','currency']),
                      importe: '+'+immCardTransferMoney.getIn(['steps','0','amount'])
                    },
                    jtipoliqtipoLiquidacion: immCardTransferMoneyCardDetails.get('jtipoliqtipoLiquidacion'),
                    mlforpagcodigoFormaPago: immCardTransferMoneyCardDetails.get('mlforpagcodigoFormaPago'),
                    nomsprodtipoTarjeta: immCardTransferMoneyCardDetails.get('nomsprodtipoTarjeta'),
                    numbenefnumeroBeneficiario: immCardTransferMoneyCardDetails.get('numbenefnumeroBeneficiario'),
                    nutarbennumeroSecuencialTarjeta: immCardTransferMoneyCardDetails.get('nutarbennumeroSecuencialTarjeta'),
                    panmdpnumeroTarjeta: immCardTransferMoneyCardDetails.get('panmdpnumeroTarjeta')
                  }
            };
        }

        dispatch(requestTransfer());
        APIPost(dispatch, apiURLBuilder.getURL('cardDirectMoneyConfirmation'), requestData)
            .then(response => dispatch(successTransfer(response)))
            .catch(error => dispatch(failureTransfer(error)));
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    setAmount,
    setVisibleStep,
    validateStep,
    setWillCancel,
    clearRequest,
    postTransfer,
    setTotalAvailableBalance,
    getTransferMoneyFromCCToAccountDetails
}
